import { gql } from "@apollo/client";

export const UpdateStockCompanyItemOB = gql`
  mutation UpdateStockCompanyItemOB(
    $token: String!
    $itemLdgrID: ID!
    $user_details: SubscribedUser!
    $input: UpdateObInput!
  ) {
    UpdateStockCompanyItemOB(
      token: $token
      itemLdgrID: $itemLdgrID
      user_details: $user_details
      input: $input
    )
  }
`;
